import { library } from '@fortawesome/fontawesome-svg-core'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStroopwafel, faLink, faSpinner,faEye } from '@fortawesome/free-solid-svg-icons'
import { faGoogle } from '@fortawesome/free-brands-svg-icons'

library.add(faStroopwafel)
library.add(faGoogle)
library.add(faEye)
library.add(faSpinner)
library.add(faLink)




// WEBPACK FOOTER //
// ./src/utils/fontAwesome.js